'use client';

import { getClientApplicationContext } from '@hc-frontend/core-context';
import { createContext, useContext, useEffect } from 'react';

import type { CompleteTrackingRepository } from '../../../domain';

export const CompleteTrackingContext =
  createContext<CompleteTrackingRepository>({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    pageView: () => {},
    tracking: {
      sessionId: '',
      userId: '',
    },
  } as CompleteTrackingRepository);

export const useCompleteTrackingContext = () => {
  const completeTracking = useContext(CompleteTrackingContext);
  useEffect(() => {
    const context = getClientApplicationContext(useCompleteTrackingContext);

    if (!completeTracking || !completeTracking.tracker)
      context.log({
        context: 'client',
        message: 'sessionCouldNotBeLoaded',

        type: 'error',
        data: {
          rootCause: new Error(
            'CompleteTrackingContext is not initialized. Please check if the provider is properly set.',
          ),
        },
      });
  }, [completeTracking]);

  return completeTracking;
};
